import { fs } from './fb';
import {
  deleteDoc,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  writeBatch,
  onSnapshot,
  collection,
  deleteField,
} from 'firebase/firestore';

const fsDocRef = (path) => doc(fs, path);

const fsGetDoc = async (path) => {
  const docRef = doc(fs, path);
  const docSnap = await getDoc(docRef);
  return docSnap;
};

const fsSetDoc = async (path, data) => {
  const docRef = doc(fs, path);
  const docSnap = await setDoc(docRef, data);
  return docSnap;
};

const fsUpdateDoc = async (path, data) => {
  const docRef = doc(fs, path);
  const docSnap = await updateDoc(docRef, data);
  return docSnap;
};

const fsDeleteDoc = async (path) => {
  const docRef = doc(fs, path);
  const docSnap = await deleteDoc(docRef);
  return docSnap;
};

const fsWriteBatch = () => writeBatch(fs);

const fsDocListener = (path, fn, onError) => {
  const docRef = doc(fs, path);
  const listener = onSnapshot(docRef, fn, onError);
  return listener;
};

const fsCollectionListener = (path, fn, onError) => {
  const collectionRef = collection(fs, path);
  const listener = onSnapshot(collectionRef, fn, onError);
  return listener;
};

export {
  fsDocRef,
  fsGetDoc,
  fsSetDoc,
  fsUpdateDoc,
  fsDeleteDoc,
  fsWriteBatch,
  fsDocListener,
  fsCollectionListener,
  deleteField as fsDeleteField,
};
